import type { ZodIssue } from 'zod';

const CUSTOM = new Set([
  'requiredWithRate',
  'countryCode',
  'link',
  'percentRange',
  'fixedRange',
  'codeChars',
  'order',
  'team_size_min_required',
  'team_size_max_below_min',
]);

/**
 * i18n key (`admin.error.<key>`) for an issue raised by a shared admin schema: the custom rules
 * carry their key as message; built-in checks map by kind.
 */
export function adminIssueKey(issue: ZodIssue): string {
  if (CUSTOM.has(issue.message)) return issue.message;
  if (issue.path[0] === 'code' && (issue.code === 'too_small' || issue.code === 'too_big'))
    return 'codeLength';
  if (issue.path[0] === 'insuranceRateBps') return 'rateRange';
  if (issue.code === 'too_small' && issue.type === 'string') return 'required';
  if (issue.code === 'invalid_string' && issue.validation === 'email') return 'email';
  if (issue.message === 'https' || issue.code === 'invalid_string') return 'url';
  return 'invalid';
}

/** Message for a failed admin write: the API error code when known, else the generic one. */
export function adminApiErrorKey(error: unknown): string {
  const code = (error as { code?: unknown } | null)?.code;
  return typeof code === 'string' && KNOWN_CODES.has(code) ? code : 'generic';
}

const KNOWN_CODES = new Set([
  'slug_taken',
  'capacity_below_taken',
  'format_has_registrations',
  'tier_overlap',
  'tier_referenced',
  'switch_in_past',
  'switch_outside_tier',
  'code_taken',
  'voucher_frozen',
  'max_uses_below_uses',
  'unknown_format',
  'invalid_voucher',
  'member_not_paid',
  'team_cancelled',
  'no_captain',
  'already_joined',
  'already_member',
  'already_registered',
  'team_full',
  'rate_limited',
  'same_team',
  'other_format',
  'team_not_cancelled',
]);
